<div class="field">
    <label [for]="inputId()">{{ label() }}</label>
    <cl-password [inputId]="inputId()" [placeholder]="placeholder()" [formControl]="control()" [autocomplete]="autocomplete()" />
    <app-form-error [errors]="control().errors" [visible]="control().touched && !!control().errors" />
</div>
